import useExternalUsers from "@/hooks/data/useExternalUsers";
import { createContext } from "react"

export interface IExternalUsersContext extends ReturnType<typeof useExternalUsers> {
}

export const ExternalUsersContext = createContext<IExternalUsersContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ExternalUsersContext;